import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-paginator',
  imports: [ReactiveFormsModule],
  templateUrl: './paginator.html',
  styleUrl: './paginator.css',
})
export class Paginator {
  @Input() totalItems: number = 0;
  @Input() itemsPerPage!: number;
  @Input() currentPage: number = 1;
  @Output() pageChange = new EventEmitter<number>();
  @Output() limitChange = new EventEmitter<number>();

  private readonly FormBuilder = inject(FormBuilder);
  form!: FormGroup;

  constructor() {
    this.buildForm();
  }

  private buildForm() {
    this.form = this.FormBuilder.group({
      page: [, [Validators.required]],
    });

    this.form.valueChanges.subscribe((value) => {
      if (value.page !== this.itemsPerPage) {
        this.handleLimitChange(value.page);
      }
    });
  }

  ngOnInit() {
    this.form.get('page')?.setValue(this.itemsPerPage);
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  rowsPerPageSelector(): number[] {
    return [10, 20, 50, 100];
  }

  handlePageChange(newPage: number) {
    this.changePage(newPage);
  }

  handleLimitChange(newLimit: number) {
    this.limitChange.emit(newLimit);
  }

  calculatePageNumbers(): number[] {
    const totalPages = this.totalPages;
    const pageNumbers: number[] = [];
    for (let i = this.currentPage - 1; i <= totalPages; i++) {
      if (i < 1) continue;
      pageNumbers.push(i);
      if (pageNumbers.length === 4 && i < totalPages) {
        // pageNumbers.pop();
        pageNumbers.push(totalPages);
      }

      if (pageNumbers.length >= 4) {
        break;
      }
    }

    if (totalPages > 5 && this.currentPage > 3) {
      pageNumbers.unshift(1);
    }
    return pageNumbers;
  }
}
